import React from 'react';

import { DutchieIntelligenceServiceErrorBoundary } from '../error-boundary';

import { ActionRegistry } from './action-registry';
import { DOMObserverResource } from './dom-observer-resource/index';
import { NavigationResource } from './navigation-resource/index';
import { ReactQueryResource } from './react-query-resource/index';
import { RecoilResource } from './recoil-resource/index';

/**
 * ServiceContextBridges - Renders all automatic context bridges.
 *
 * This component consolidates all the integration bridges that automatically
 * register context from various sources:
 * - ActionRegistry: Registers available AI actions
 * - ReactQueryResource: Auto-registers React Query data
 * - RecoilResource: Auto-registers Recoil global state
 * - NavigationResource: Auto-registers routing information
 * - DOMObserverResource: Auto-detects DOM elements (forms, tables, actions)
 *
 * Each bridge is wrapped in an error boundary to prevent one failing bridge
 * from breaking the entire service.
 *
 * Must be rendered inside DutchieIntelligenceProvider to have access to context registration methods.
 */
export function ServiceContextBridges() {
  return (
    <>
      <DutchieIntelligenceServiceErrorBoundary>
        <ActionRegistry />
      </DutchieIntelligenceServiceErrorBoundary>

      <DutchieIntelligenceServiceErrorBoundary>
        <ReactQueryResource />
      </DutchieIntelligenceServiceErrorBoundary>

      <DutchieIntelligenceServiceErrorBoundary>
        <RecoilResource />
      </DutchieIntelligenceServiceErrorBoundary>

      <DutchieIntelligenceServiceErrorBoundary>
        <NavigationResource />
      </DutchieIntelligenceServiceErrorBoundary>

      <DutchieIntelligenceServiceErrorBoundary>
        <DOMObserverResource />
      </DutchieIntelligenceServiceErrorBoundary>
    </>
  );
}
